import { render, staticRenderFns } from "./clampMe.vue?vue&type=template&id=f8ca83b6&scoped=true&"
import script from "./clampMe.vue?vue&type=script&lang=js&"
export * from "./clampMe.vue?vue&type=script&lang=js&"
import style0 from "./clampMe.vue?vue&type=style&index=0&id=f8ca83b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8ca83b6",
  null
  
)

export default component.exports